import { ColumnDisplayPopover } from "./ColumnDisplayPopover";
import { useDataTablePreferences } from "./useDataTablePreferences";
import type { TableColumnDef } from "./types";

interface DataTableColumnSettingsProps<T> {
  columns: TableColumnDef<T>[];
  className?: string;
}

/** Place in CardHeader (right side). Requires DataTableProvider wrapper. */
export function DataTableColumnSettings<T>({
  columns,
  className,
}: DataTableColumnSettingsProps<T>) {
  const prefs = useDataTablePreferences<T>();
  if (!prefs) {
    return null;
  }

  const columnLabels = Object.fromEntries(
    columns.filter(c => !c.hideFromDisplay).map(c => [c.id, c.label])
  );
  const lockVisibilityIds = new Set(
    columns.filter(c => c.lockVisibility).map(c => c.id)
  );

  if (prefs.menuColumns.length === 0) {
    return null;
  }

  return (
    <ColumnDisplayPopover
      className={className}
      columns={prefs.menuColumns}
      labels={columnLabels}
      lockVisibilityIds={lockVisibilityIds}
      onVisibleChange={prefs.setVisible}
      onAllVisibleChange={prefs.setAllVisible}
      onPinChange={prefs.setPin}
      onReorder={prefs.reorderColumns}
      onReset={prefs.reset}
    />
  );
}
